// The three sections of a squad's page, named once so the type derives from the values and the
// `scheda` param cannot hold a fourth. «partite» is the one the page opens on, and stays out of the URL.

export const TEAM_SECTIONS = ['partite', 'rosa', 'staff'] as const

export type TeamSection = (typeof TEAM_SECTIONS)[number]
